import type { IconProps } from './types';
import './icons.css';

export default function Hide({
  width,
  height,
  className = '',
}: IconProps): React.JSX.Element {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width || 16}
      height={height || 16}
      viewBox="0 0 16 16"
      className={`icon icon-hide ${className || ''}`}
      fill="none"
    >
      <path
        d="M1.833 14.166 14.166 1.833"
        stroke="currentColor"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M7.996 3c.86 0 1.7.133 2.497.387l-.82.82A6.875 6.875 0 0 0 7.996 4C4.776 4 1.76 6.273.983 9.29a.494.494 0 0
        1-.607.36.494.494 0 0 1-.36-.607C.916 5.54 4.273 3 7.996 3ZM15.623 9.65a.498.498 0 0
        1-.607-.36c-.503-1.957-1.953-3.604-3.79-4.517l.754-.753c1.947 1.053 3.447 2.853 4.003 5.023.07.267-.09.54-.36.607Z"
        fill="currentColor"
      />
      <path
        d="m9.79 6.21-.726.727c.69.377 1.16 1.11 1.16 1.953A2.223 2.223 0 0 1 6.05 9.95l-.727.727A3.223 3.223 0 0 0
        8 12.11a3.227 3.227 0 0 0 3.224-3.22c0-1.113-.57-2.1-1.434-2.68Zm-2.846.727 1.263-1.263a3.225 3.225 0 0 0-3.42
        3.42L6.05 7.83c.204-.376.517-.69.894-.893Z"
        fill="currentColor"
      />
    </svg>
  );
}
